<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          Edit Invoice</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row class="mt-1">
          <b-col cols="6">
            <b-form-group
              label="Consultant Name"
              label-cols-md="4"
              label-align="right"
            >
              <div class="form-control">
                <span
                  v-for="option in invoice.employee_names"
                  :key="option"
                >
                  <span v-text="option" />
                </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Period"
              label-cols-md="4"
              label-align="right"
            >
              <span
                class="form-control"
                v-text="invoice.period"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Received Date"
              label-cols-md="4"
              label-align="right"
            >
              <span
                class="form-control"
                v-text="invoice.received_date"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Amount"
              label-cols-md="4"
              label-align="right"
            >
              <validation-provider
                #default="{ errors }"
                name="Amount"
                rules="required"
              >
                <b-input-group
                  prepend="$"
                >
                  <money
                    v-model="invoice.total_amount"
                    :min="0"
                    :step="0.5"
                    v-bind="money"
                    class="form-control"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Number of Hours"
              label-cols-md="4"
              label-align="right"
            >
              <span
                class="form-control"
                v-text="invoice.hours"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Invoice #"
              label-cols-md="4"
              label-align="right"
            >
              <span
                class="form-control"
                v-text="invoice.name"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
          >
            <b-form-group
              label="Expenses"
              label-cols-md="4"
              class="text-right"
            >
              <validation-provider
                #default="{ errors }"
                name="Expenses"
                rules="required"
              >
                <b-input-group
                  prepend="$"
                >
                  <money
                    v-model="invoice.expenses"
                    :min="0"
                    :step="0.5"
                    v-bind="money"
                    class="form-control"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Status"
              label-cols-md="4"
              label-align="right"
            >
              <span
                class="form-control"
                v-text="invoice.status"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Reject Reason"
              label-cols-md="4"
              label-align="right"
            >
              <b-form-textarea
                v-model="invoice.reject_reason"
                disabled
                rows="2"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <div v-if="invoice.corrected_invoice != null">
          <div class="d-flex mt-2">
            <h4 class="mb-0 ml-50">
              Corrected Invoice
            </h4>
          </div>
          <b-row class="mt-2">
            <b-col cols="6">
              <b-form-group
                label="Invoice Number"
                label-cols-md="4"
                label-align="right"
              >
                <span
                  class="form-control"
                  v-text="invoice.corrected_invoice.number"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Invoice Amount"
                label-cols-md="4"
                label-align="right"
              >
                <span class="form-control">{{ invoice.corrected_invoice.amount | currency('$ ', 2, { thousandsSeparator: ',' }) }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
        </div>

        <div class="d-flex mt-2">
          <h4 class="mb-0 ml-50">
            Documents
          </h4>
        </div>
        <b-row class="mt-1">
          <b-col cols="6">
            <b-form-group
              label="Type"
              label-cols-md="4"
              class="text-right"
            >
              <v-select
                v-model="documentNameId"
                :clearable="true"
                placeholder="Select"
                :options="documentNames"
                :reduce="item => item.id"
              />
            </b-form-group>
            <b-form-group
              label="Attachment"
              label-cols-md="4"
              class="text-right"
            >
              <div class="d-flex">
                <input
                  ref="myFileInput"
                  type="file"
                  placeholder="Choose a file or drop it here..."
                  class="form-control text-left"
                  @change="attahamentFileSelected"
                >
                <b-button
                  variant="outline-primary"
                  class="ml-1 px-1"
                  @click="addFile"
                >
                  Upload
                </b-button>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-button-group
              v-for="(option, index) in invoice.documents"
              :key="option.id"
              :value="option.id"
              class="mr-1"
            >
              <b-badge
                :href="option.attachment_link"
                :title="option.name"
                target="option.attachment_link"
                variant="light-primary"
                class="rounded-right-0 line-height-inherit"
              >
                <span>{{ option.name }}</span>
              </b-badge>
              <b-button
                variant="danger"
                class="px-50 py-25"
                @click="removeFile(option, index)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <hr>

        <b-row class="ml-2">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              @click="submitForm"
            >
              Update Invoice
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import {
  BCard, BRow, BCol, BForm, BFormGroup, BInputGroup, BButtonGroup, BButton, BBadge, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  required,
} from '@validations'
import User from '@/js/user'
import Invoices from '@/js/invoices'
import LIST from '@/js/lists'
import moment from 'moment'
import Constants from '@/js/constant'

export default {
  components: {
    BCard,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BInputGroup,
    vSelect,
    BButton,
    BButtonGroup,
    BBadge,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      addInvoice: {
        hours: '',
        expenses: '',
      },
      invoice: {
        name: '',
        period: '',
        user_id: '',
        user_name: '',
        hours: '',
        employee_ids: null,
        employee_names: null,
        total_amount: null,
        total_hours: null,
        status: {},
        documents: [],
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
      selectedFile: null,
      url: null,
      documentNameId: null,
      documentName: null,
      cal_total_amount: null,
      correctedInvoices: [],
      documentNames: [],
    }
  },
  mounted() {
  },
  created() {
    if (!User.profile().timesheet_provider_parents.length > 0) {
      if (User.profile().job_exist) {
        window.location.hash = '#/jobs'
      } else if (User.profile().invoice_exist) {
        window.location.hash = '#/invoices'
      } else {
        // Auth.logout()
      }
      return
    }
    Invoices.getInvoiceById(this, this.$route.params.id)
  },
  destroyed() {
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          if (this.documentNameId !== null && this.selectedFile === null) {
            this.$swal({
              title: 'Upload',
              text: 'Please choose file',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            return
          }
          if (this.documentNameId === null && this.selectedFile !== null) {
            this.$swal({
              title: 'Upload',
              text: 'Please select document type',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            return
          }
          if (this.documentNameId !== null && this.selectedFile !== null) {
            this.invoice.documents.push({
              document_name_id: this.documentNameId,
              attachment_link: this.url,
              document: this.selectedFile,
              file_name: this.documentName,
              name: this.documentName,
            })
            this.selectedFile = null
            this.url = null
            this.documentNameId = null
            this.$refs.myFileInput.value = ''
          }
          let documentExist = false
          this.invoice.documents.forEach(elem => {
            const items = this.documentNames.filter(data => data.label.toLowerCase() === 'invoice' && data.id === elem.document_name_id)
            if (items.length !== 0) {
              documentExist = true
            }
          })
          if (documentExist) {
            this.submitted = true
            this.addInvoice.time = moment().format('hh:mm a')
            this.addInvoice.date = Constants.getEprmMonthDateFromString(moment().format('MM-DD-YYYY'))
            this.addInvoice.comments = this.invoice.comments
            this.addInvoice.amount = this.invoice.total_amount
            this.addInvoice.expenses = this.invoice.expenses
            this.addInvoice.documents = this.invoice.documents
            Invoices.updateInvoice(this, this.$route.params.id)
          } else {
            this.$swal({
              title: 'Please upload invoice',
            })
          }
        }
      })
    },
    attahamentFileSelected(obj) {
      const dis = this
      const fileReader = new FileReader()
      fileReader.onload = fileLoadEvent => {
        dis.selectedFile = fileLoadEvent.target.result
      }
      fileReader.readAsDataURL(obj.target.files[0])
      this.url = URL.createObjectURL(obj.target.files[0])
      this.documentName = obj.target.files[0].name
    },
    removeFile(obj, position) {
      const dis = this
      this.$swal({
        title: 'Are you sure?',
        text: `you wan't to delete this ${obj.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          dis.invoice.documents.splice(position, 1)
        }
      })
    },
    addFile() {
      if (this.documentNameId !== null && this.selectedFile === null) {
        this.$swal({
          title: 'Error!',
          text: ' Please choose file',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        return
      }
      if (this.documentNameId === null && this.selectedFile !== null) {
        this.$swal({
          title: 'Error!',
          text: ' Please select document type',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        return
      }
      if (this.documentNameId !== null && this.selectedFile !== null) {
        this.invoice.documents.push({
          document_name_id: this.documentNameId, attachment_link: this.url, document: this.selectedFile, file_name: this.documentName, name: this.documentName,
        })
        this.selectedFile = null
        this.url = null
        this.documentNameId = null
        this.$refs.myFileInput.value = ''
      }
    },
    setCompanies(companies) {
      this.companies = companies
    },
    setDocumentNames(documentNames) {
      this.documentNames = documentNames
    },
    setInvoice(invoice) {
      this.invoice = invoice
      if (this.invoice.invoice_type.toLowerCase() === 'subvendor') {
        LIST.getDocumentNameFullList(this, 'FA', 'IS')
      } else if (this.invoice.invoice_type.toLowerCase() === 'suppliers') {
        LIST.getDocumentNameFullList(this, 'FA', 'IP')
      } else if (this.invoice.invoice_type.toLowerCase() === 'referrer') {
        LIST.getDocumentNameFullList(this, 'FA', 'IR')
      } else {
        LIST.getDocumentNameFullList(this, 'FA', 'IE')
      }
    },
    amountChanged() {
      this.$swal({
        title: 'proceed',
        text: 'You had changed caliculated amount are you sure want to continue',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          Invoices.updateInvoice(this, this.$route.params.id)
        }
      })
    },
    setVendorAmount(amount) {
      this.addInvoice.invoice_amount = amount.amount
      this.addInvoice.expenses = amount.expenses
      this.addInvoice.hours = amount.hours
      this.cal_total_amount = amount.amount
      this.addInvoice.timesheet_ids = amount.timesheet_ids
    },
    invoiceUpdated(data) {
      this.$refs.showLoading = false
      this.back()
      this.$swal({
        title: 'Success!',
        text: data.return_message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    invoiceNotUpdated(message) {
      this.$refs.showLoading = false
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    back() {
      this.$router.push('/invoices').catch(() => {})
    },
  },
  setup() {
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
